import resolveGclid from './gclidAttribution';

resolveGclid();
